export default __webpack_public_path__ + "static/media/bg.b25a4267.jpg";